module.exports = __webpack_public_path__ + "static/img/pp.e11b28b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pp.png
// module id = 4Qvw
// module chunks = 1